import { MessageCircle } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { PhotoCarousel } from "@/components/PhotoCarousel";
import { api, inr, waLink, orderMessage } from "@/lib/api";

export function ProductModal({ product, onClose, whatsappNumber }) {
  if (!product) return null;
  const photos = (product.images && product.images.length ? product.images : [product.image_url]).filter(Boolean);
  const onSale = product.mrp && Number(product.mrp) > Number(product.price);
  const wa = waLink(whatsappNumber, orderMessage(product));
  return (
    <Dialog open={!!product} onOpenChange={(open) => !open && onClose()}>
      <DialogContent data-testid="product-modal" className="max-w-2xl p-0 overflow-hidden gap-0 border-gold-line">
        <div className="grid sm:grid-cols-2">
          <div className="relative">
            <PhotoCarousel photos={photos} alt={product.name} />
            {onSale ? (
              <span data-testid="modal-sale-badge" className="absolute top-4 right-4 z-10 rounded-full bg-maroon border border-gold px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-gold-soft">
                Festive Sale
              </span>
            ) : null}
          </div>
          <div className="flex flex-col p-6 sm:p-8">
            {product.tag ? (
              <span className="mb-3 self-start rounded-full bg-gold-soft border border-gold-line px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-maroon">
                {product.tag}
              </span>
            ) : null}
            <DialogTitle data-testid="modal-product-name" className="font-display text-2xl sm:text-3xl font-semibold text-maroon-dark leading-tight">
              {product.name}
            </DialogTitle>
            <div className="mt-2 flex items-baseline gap-3">
              <p data-testid="modal-product-price" className="text-2xl font-bold text-maroon">{inr(product.price)}</p>
              {onSale ? (
                <p data-testid="modal-product-mrp" className="text-sm text-ink-muted line-through">{inr(product.mrp)}</p>
              ) : null}
            </div>
            <p data-testid="modal-product-description" className="mt-4 text-sm leading-relaxed text-ink-muted">{product.description || "Message us on WhatsApp for full details of this product."}</p>
            <p className="mt-2 text-[11px] uppercase tracking-wider text-gold-text font-semibold">{product.category}</p>
            <a
              data-testid="modal-whatsapp-order-btn"
              href={wa}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => api.post(`/products/${product.id}/tap`).catch(() => {})}
              className="mt-auto pt-6 inline-flex items-center justify-center gap-2 rounded-full bg-whats px-6 py-3 font-semibold text-white hover:bg-whats-dark transition-colors duration-200"
            >
              <MessageCircle className="w-5 h-5" />
              Order on WhatsApp
            </a>
            <p className="mt-3 text-center text-xs text-ink-muted">Tap to open WhatsApp with a ready message</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
